import {API_PATH} from '@app/common/constants';
import {NetworkService, ToasterService} from '@app/services';
import {ToastType} from '@app/services/toaster';
import {takeLatest, put, call} from 'redux-saga/effects';
import {
  fetchBypassExpensePendingReportCreator,
  fetchBypassExpensePendingReportCreatorTypeName,
  approveBypassExpensesCreatorTypeName,
  bypassExpenseStateActions,
} from './slice';

export function* fetchBypassExpensePendingReportWatcher() {
  yield takeLatest(
    fetchBypassExpensePendingReportCreatorTypeName,
    fetchBypassExpensePendingReportWorker,
  );
}

export function* fetchBypassExpensePendingReportWorker(action: any): any {
  try {
    const {payload} = action;
    if (payload) {
      yield put(bypassExpenseStateActions.setBypassExpenseGridLoading(true));
      yield put(bypassExpenseStateActions.setBypassExpenseSelectedExpenseIds([]));
      const url = `${API_PATH.bypassExpense.pendingManagerExpenseReport}`;
      const response = yield call(NetworkService.post, url, {
        years: payload.years,
        months: payload.months,
        sapCodes: payload.sapCodes,
        divisionIds: payload.divisionIds,
        stateName: payload.stateName,
      });
      yield put(
        bypassExpenseStateActions.setBypassExpenseGridData(
          response?.data?.gridData ?? response?.data ?? [],
        ),
      );
      yield put(bypassExpenseStateActions.setBypassExpenseGridLoading(false));
    }
  } catch (error) {
    yield put(bypassExpenseStateActions.setBypassExpenseGridLoading(false));
  }
}

export function* approveBypassExpensesWatcher() {
  yield takeLatest(
    approveBypassExpensesCreatorTypeName,
    approveBypassExpensesWorker,
  );
}

export function* approveBypassExpensesWorker(action: any): any {
  try {
    const {payload} = action;
    if (payload?.expenseIdList) {
      yield put(bypassExpenseStateActions.setIsLoading(true));
      const url = `${API_PATH.bypassExpense.updateExpenseStatus}`;
      const response = yield call(NetworkService.put, url, {
        expenseIdList: payload.expenseIdList,
      });
      if (response?.data?.error) {
        yield put(bypassExpenseStateActions.setIsLoading(false));
        ToasterService.showToaster(response.data.error, ToastType.ERROR);
      } else if (response?.status === 200) {
        yield put(bypassExpenseStateActions.setIsLoading(false));
        yield put(bypassExpenseStateActions.setBypassExpenseSelectedExpenseIds([]));
        ToasterService.showToaster(
          'Expense(s) approved successfully',
          ToastType.SUCCESS,
        );
        if (payload.filterParams) {
          yield put(fetchBypassExpensePendingReportCreator(payload.filterParams));
        }
      }else{
            yield put(bypassExpenseStateActions.setIsLoading(false));

      }
    }
  } catch (error) {
    yield put(bypassExpenseStateActions.setIsLoading(false));
  }
}
